import Navbar from "@/features/Navbar/Navbar";
import Footer from "@/features/Footer/Footer";
import styles from "./MainLayout.module.css";
import { Outlet } from "react-router";
import { Cookies } from "@/features/Cookies";

export interface MainLayoutProps {
  showNavbar?: boolean;
  showFooter?: boolean;
}

function MainLayout({ showNavbar = true, showFooter = true }: MainLayoutProps) {
  return (
    <div className={styles.mainLayout}>
      {showNavbar && <Navbar />}

      <main className={styles.mainContent}>
        <Outlet />
      </main>

      {showFooter && <Footer />}
      <Cookies />
    </div>
  );
}

export default MainLayout;
